import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { FormInstancesService } from '@app/api/api-services/form-instances.service';
import { map, switchMap } from 'rxjs/operators';
import { CheckNumberRequestApiModel } from '@app/api/api-models/form-instance/CheckNumberRequestApiModel';
import { ValidationErrorDetails } from '../validation-error-details';
import { FormInstanceValidatorParams } from '../form-instance/form-instance-validator-params';
import { of, timer } from 'rxjs';

export function isInstancesNumberTakenAsyncValidator(
  formInstancesService: FormInstancesService,
  formInstanceId: number,
  formInstanceName: string,
  phaseControl: AbstractControl
): AsyncValidatorFn {
  return (control: AbstractControl, time = 500) => {
    if (
      (phaseControl.enabled && phaseControl.value === null) ||
      control.value === null ||
      control.value.trim() === ''
    ) {
      return of(null);
    }

    return timer(time).pipe(
      switchMap(() =>
        formInstancesService.checkNumber(
          new CheckNumberRequestApiModel(control.value, formInstanceId, phaseControl.value)
        )
      ),
      map((res) => {
        const result = new FormInstanceValidatorParams();
        result.instanceNumberTaken = new ValidationErrorDetails(true, { formInstanceName: formInstanceName });
        return res.Value ? null : result;
      })
    );
  };
}
